<template>
  <div>
    <PageHeaderBanner>
      <template #title>
        <span>商品情報変更</span>
      </template>
    </PageHeaderBanner>
    <MessageChip :display="isMessageChip" level="E" :message="errMessage" />
    <q-form
      autofocus
      greedy
      @submit.prevent="isConfirmationFlg = true"
      @reset="reset"
      @validation-error="resetErrors"
    >
      <div class="cmd00810-input-form q-gutter-y-xs">
        <div class="row q-gutter-x-sm">
          <div class="structure-area">
            <label>構造式</label>
            <AtomImage
              :exatoms="updateData.structure"
              style="
                margin-top: 8px;
                border: 1px solid var(--q-lightColorBorder);
                border-radius: 3px;
              "
            />
          </div>
          <div class="structure-right q-gutter-y-xs">
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>ATTO_ID</label>
                <p class="q-mb-none q-ml-sm q-mt-sm">{{ updateData.atto_id }}</p>
              </div>
              <div class="col">
                <label class="requier">サプライヤ商品コード</label>
                <q-input
                  v-model="updateData.id_number"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area left-input"
                  maxlength="200"
                  :rules="[
                    (val) => isEmpty(val) || $t('validation.required'),
                    (val) => isHalfAlphanumericsymbol(val) || $t('validation.half_alphanumsymbol'),
                  ]"
                  lazy-rules
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>CAS No.</label>
                <q-input
                  v-model="updateData.cas_number"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area left-input"
                  maxlength="30"
                  :rules="[
                    (val) => isHalfAlphanumericsymbol(val) || $t('validation.half_alphanumsymbol'),
                  ]"
                  lazy-rules
                  @keydown.enter.prevent
                />
              </div>
              <div class="col">
                <label>MDL</label>
                <q-input
                  v-model="updateData.mdl"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area left-input"
                  maxlength="30"
                  :rules="[
                    (val) => isHalfAlphanumericsymbol(val) || $t('validation.half_alphanumsymbol'),
                  ]"
                  lazy-rules
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>化学名1</label>
                <q-input
                  v-model="updateData.name1"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="2000"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>化学名2</label>
                <q-input
                  v-model="updateData.name2"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="2000"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>Purity</label>
                <q-input
                  v-model="updateData.purity"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="100"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
              <div class="col">
                <label>Storage</label>
                <q-input
                  v-model="updateData.storage"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="200"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>Hazard Information</label>
                <q-input
                  v-model="updateData.hazard_info"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="200"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
              <div class="col">
                <label>Solubility</label>
                <q-input
                  v-model="updateData.solubility"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="200"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label>Target</label>
                <q-input
                  v-model="updateData.target"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="200"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>Supplier_URL</label>
                <q-input
                  v-model="updateData.url"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area left-input"
                  maxlength="300"
                  :rules="[
                    (val) => isHalfAlphanumericsymbol(val) || $t('validation.half_alphanumsymbol'),
                  ]"
                  lazy-rules
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>備考</label>
                <q-input
                  v-model="updateData.memo"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="200"
                  lazy-rules
                  hint=""
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="row q-gutter-x-sm">
              <div class="col">
                <label>CoA</label>
                <q-input
                  v-model="updateData.coa"
                  outlined
                  dense
                  style="background: var(--q-white)"
                  class="input-area"
                  maxlength="300"
                  lazy-rules
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormFooterBanner style="position: inherit">
        <template #button-area>
          <div class="cmd00810-button-area row">
            <q-btn
              color="grey-7"
              outline
              label="戻る"
              style="min-width: 120px; background: var(--q-white) !important"
              @click="pageBack"
            />
            <div class="col q-gutter-x-xs flex justify-end">
              <q-btn color="primary" style="width: 150px" label="変更" type="submit" />
              <q-btn
                outline
                style="width: 150px; background: var(--q-white) !important; color: var(--q-delete)"
                icon="cached"
                label="リセット"
                @click="reset"
              />
            </div>
          </div>
        </template>
      </FormFooterBanner>
    </q-form>
    <AlertDialog
      :display="isConfirmationFlg"
      level="information"
      :title="'更新確認'"
      :text="['入力された内容で更新します', 'よろしいですか？']"
      @confirm="updateGoods()"
      @close="isConfirmationFlg = false"
    />
    <AlertDialog
      :display="edit"
      level="information"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="pageBack"
      @close="edit = false"
    />
  </div>
</template>
<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';

import http from '../../common/axios-common';
import { isEmpty, isHalfAlphanumericsymbol } from '../../common/utils/validateUtils';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AtomImage from '../../components/images/AtomImage.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';

// 初期表示データ
const initData = reactive({
  structure: '',
  atto_id: '',
  id_number: '',
  catalog_id: '',
  cas_number: '',
  mdl: '',
  name1: '',
  name2: '',
  purity: '',
  storage: '',
  hazard_info: '',
  solubility: '',
  target: '',
  memo: '',
  url: '',
  coa: '',
});

interface Props {
  // 商品ID
  molId: string;
}

const props = defineProps<Props>();

// 更新確認ダイアログ表示
const isConfirmationFlg = ref(false);
// ダイアログ表示
const edit = ref(false);

const router = useRouter();

// ダイアログのtitle
const dialogTitle = ref('');

// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);

// 商品ID
const molId = ref(props.molId);

// MessageChip表示フラグ
const isMessageChip = ref(false);

// エラーメッセージ
const errMessage = ref('');

// 取得したデータ
const updateData = ref({ ...initData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

// 初期表示
const init = () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('molId', molId.value);
  //  初期表示
  http
    .post('/cmd008101/requestDetailGoods', formData)
    .then((response) => {
      const { common, molInfoDto } = response.data;
      switch (common.status) {
        case ResultStatusCode.SUCCESS:
          // 初期表示データ
          Object.assign(initData, molInfoDto);
          initData.cas_number = molInfoDto.cas_number ? molInfoDto.cas_number : '';
          initData.mdl = molInfoDto.mdl ? molInfoDto.mdl : '';
          initData.name1 = molInfoDto.name1 ? molInfoDto.name1 : '';
          initData.name2 = molInfoDto.name2 ? molInfoDto.name2 : '';
          initData.purity = molInfoDto.purity ? molInfoDto.purity : '';
          initData.storage = molInfoDto.storage ? molInfoDto.storage : '';
          initData.hazard_info = molInfoDto.hazard_info ? molInfoDto.hazard_info : '';
          initData.solubility = molInfoDto.solubility ? molInfoDto.solubility : '';
          initData.target = molInfoDto.target ? molInfoDto.target : '';
          initData.memo = molInfoDto.memo ? molInfoDto.memo : '';
          initData.url = molInfoDto.url ? molInfoDto.url : '';
          initData.coa = molInfoDto.coa ? molInfoDto.coa : '';
          // 変更用データ
          updateData.value = molInfoDto;
          updateData.value.cas_number = molInfoDto.cas_number ? molInfoDto.cas_number : '';
          updateData.value.mdl = molInfoDto.mdl ? molInfoDto.mdl : '';
          updateData.value.name1 = molInfoDto.name1 ? molInfoDto.name1 : '';
          updateData.value.name2 = molInfoDto.name2 ? molInfoDto.name2 : '';
          updateData.value.purity = molInfoDto.purity ? molInfoDto.purity : '';
          updateData.value.storage = molInfoDto.storage ? molInfoDto.storage : '';
          updateData.value.hazard_info = molInfoDto.hazard_info ? molInfoDto.hazard_info : '';
          updateData.value.solubility = molInfoDto.solubility ? molInfoDto.solubility : '';
          updateData.value.target = molInfoDto.target ? molInfoDto.target : '';
          updateData.value.memo = molInfoDto.memo ? molInfoDto.memo : '';
          updateData.value.url = molInfoDto.url ? molInfoDto.url : '';
          updateData.value.coa = molInfoDto.coa ? molInfoDto.coa : '';
          break;

        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // 商品情報が存在しない場合
            case DetailResultStatusCode.NOT_MOL_ERROR:
              errMessage.value = response.data.common.message;
              isMessageChip.value = true;
              break;
            default:
              router.push({ name: 'error' });
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 商品情報変更
const updateGoods = async () => {
  isConfirmationFlg.value = false;
  resetErrors();
  // Loading Start
  Loading.show();
  // 変更データ
  const formData = new FormData();
  formData.append('molId', molId.value);
  formData.append('idNumber', updateData.value.id_number);
  formData.append('catalogId', updateData.value.catalog_id);
  formData.append('cas', updateData.value.cas_number);
  formData.append('mdl', updateData.value.mdl);
  formData.append('name1', updateData.value.name1);
  formData.append('name2', updateData.value.name2);
  formData.append('purity', updateData.value.purity);
  formData.append('storage', updateData.value.storage);
  formData.append('hazardInfo', updateData.value.hazard_info);
  formData.append('solubility', updateData.value.solubility);
  formData.append('target', updateData.value.target);
  formData.append('memo', updateData.value.memo);
  formData.append('url', updateData.value.url);
  formData.append('coa', updateData.value.coa);
  // 商品情報変更
  await http
    .post('/cmd008101/updateGoods', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        if (
          response.data.common.detail_status === DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR
        ) {
          // 重複エラー
          errMessage.value = response.data.common.message;
          isMessageChip.value = true;
        } else if (response.data.common.detail_status === DetailResultStatusCode.UPDATE_ERROR) {
          // 更新エラー
          errMessage.value = response.data.common.message;
          isMessageChip.value = true;
        } else if (response.data.common.detail_status === DetailResultStatusCode.PARAMETER_ERROR) {
          // 単項目チェック
          router.push({ name: 'error' });
        } else {
          // エラー画面遷移
          router.push({ name: 'error' });
        }
      } else {
        // 更新完了
        edit.value = true;
        dialogTitle.value = '更新完了';
        dialogText.value = [response.data.common.message];
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// リセットボタン押下
const reset = () => {
  resetErrors();
  updateData.value = { ...initData };
};

// 戻るボタン押下
const pageBack = () => {
  router.replace({ name: 'catalog' });
};

// 初期表示
// propsが存在しない場合
if (!props.molId) {
  // 前画面に遷移
  pageBack();
} else {
  init();
}
</script>
<style scoped>
.cmd00810-input-form {
  width: 80%;
  margin: 0 auto;
}
.cmd00810-button-area {
  width: 82%;
  margin: 0 auto;
}
.structure-area {
  width: 40%;
  max-width: 450px;
  margin: 0;
  margin-right: 2%;
}
.structure-right {
  width: 58%;
  margin: 0;
}
</style>
